<template>
  <div
    ref="wrapper"
    class="markers-swiper">
    <f7-swiper
      v-if="width && swiper.length"
      :key="swiper.map(p => p._id).join('-')"
      ref="markers"
      class="marker-swiper-containter"
      pagination
      :params="{
        width,
        slidesPerView,
        height: 150,
        speed: 500,
        centeredSlides: true,
        /* spaceBetween: 20, */
        /* effect: 'coverflow',
        coverflowEffect: {
          rotate,
          depth,
          slideShadows: false,
        }, */
        on: { slideChange }
      }">
      <f7-swiper-slide
        v-for="m in swiper"
        :key="m._id">
        <div style="padding:0 10px">
          <transition
            name="fadein">

            <SpeechPlaylist
              v-if="markerSpeech && m._id === markerSpeech._id" />

            <PlayerCover
              v-else
              :marker="m"
              :wiki="m.wiki"
              @play="play"
              @load="load">
              <CloudImage
                :src="m.image"
                :rounded="6"
                :width="800"
                :height="400"
                fluid
                background />
            </PlayerCover>
          </transition>

          <f7-row
            class="swiper-actions">
            <f7-col>
              <RouteDropdown
                large
                :marker="m"
                @open="$emit('closeSheet')" />
            </f7-col>
            <f7-col>
              <f7-button
                class="cta-detail"
                large
                raised
                @click="read(m)">
                <FlatIcon
                  :size="20"
                  name="info-blue" />
                {{ t('footerRead') }}
              </f7-button>
            </f7-col>
          </f7-row>
        </div>

      </f7-swiper-slide>
    </f7-swiper>
  </div>
</template>

<script>
import SpeechPlaylist from '@/components/hl/SpeechPlaylist'
import PlayerCover from '@/components/io/PlayerCover'
import RouteDropdown from '@/components/io/RouteDropdown'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'MarkersSwiper',
  components: {
    PlayerCover,
    SpeechPlaylist,
    RouteDropdown
  },
  props: {
    width: {
      type: Number,
      default: window.innerWidth
    }
  },
  data () {
    return {
      // width: 0,
      slide: 0,
      slidesPerView: 1.2,
      // rotate: 50,
      // depth: 100,
      selected: null
    }
  },
  computed: {
    ...mapGetters({
      swiper: 'global/swiper',
      highlight: 'global/highlight',
      markerSpeech: 'speech/markerSpeech'
    })
  },
  watch: {
    highlight (marker) {
      if (marker && this.$refs && this.$refs.markers) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.slideTo(marker._id)
          }, 100)
        })
      }
    }
  },
  methods: {
    ...mapActions({
      setHighlight: 'global/setHighlight'
    }),
    slideChange () {
      const i = this.$refs.markers.swiper.activeIndex
      const selected = this.swiper[i]
      if (selected && this.highlight && selected._id !== this.highlight._id) {
        this.slide = i
        this.selected = selected
        this.setHighlight(selected)
        this.$emit('marker', selected)
      }
    },
    read (m) {
      console.log(m)
      this.$f7router.navigate('/article/' + m._id)
    },
    play () {
      this.$emit('play')
    },
    openRouteMode () {
      this.$emit('route')
    },
    load (res) {
      const marker = this.swiper.find(m => m._id === res.marker)
      const page = res.data
      this.$emit('load', { marker, page })
    },
    slideTo (id) {
      const marker = this.swiper.find(m => m._id === id)
      if (marker && this.$refs.markers) {
        const i = this.swiper.indexOf(marker)
        this.$refs.markers.swiper.slideTo(i)
      }
    } // ,
    // setLayout (w) {
    //   // const numberOfSlides = Math.round((w * 0.8) / 150)
    //   // this.slidesPerView = numberOfSlides
    //   this.width = w
    //   // this.rotate = Math.round(100 / (numberOfSlides))
    //   // this.depth = Math.round(w * 0.8 / 320 * 100)
    // }
  } // ,
  // mounted () {
  //   this.$nextTick(() => {
  //     this.width = this.$refs.wrapper.offsetWidth
  //     // this.setLayout(this.$refs.wrapper.offsetWidth)
  //   })
  // }
}
</script>

<style lang="scss">
.markers-swiper {
  position: relative;
  padding-top: 1px;
  margin-top: -1px;
  .swiper-slide {
    padding-top: 5px;
  }
  .marker-swiper-containter {
    padding-bottom: 40px;
  }
  .player-cover {
    display: block;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 5px 0px;
    border-radius: 6px;
    // width: 100%;
    // height: 140px;
    // .player-cover-image,
    .cloud-image {
      height: 130px !important;
      position: relative;
      // img {
      //   position: absolute;
      //   top: 50%;
      //   left: 0;
      //   width: 100%;
      //   height: auto;
      // }
    }
  }
  .preloader-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .speech-playlist {
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 5px 0px;
    max-height: 140px;
    border-radius: 10px;
    overflow: hidden;
  }
  .cta-detail {
    position: relative;
    padding-left: 35px;
    .flat-icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
  .swiper-actions {
    padding-top: 16px;
  }
}
</style>
